module.exports = __webpack_public_path__ + "static/media/example.eb8e7779.png";